import { messageBus } from '@newo/message-bus';
import type { MessageBusChannel } from '@newo/message-bus';

// Host-side mirror of the Vibe Mode dock message-bus contract owned by the
// vibe-builder remote (apps/vibe-builder/src/contract/vibe-mode-dock.contract.ts
// in white-label-frontend). Keep the channel id, intents and state shape in
// sync with the remote — they are the wire format.

export enum VibeModeDockIntent {
    Open = 'open',
    Close = 'close',
    GetVibeConsultation = 'get_vibe_consultation',
    AskVibeMode = 'ask_vibe_mode',
    SessionDeleted = 'session_deleted'
}

export type OpenPayload = {
    shouldCreateNewSession?: boolean;
};

export type AskVibeModePayload = {
    prompt: string;
};

export enum VibeConsultationType {
    Attributes = 'attributes'
}

export type VibeConsultationPayload = {
    url: string;
    updatedValue: string;
    consultationType: VibeConsultationType;
    attributeIdn: string;
};

export type SessionDeletedPayload = {
    actorId: string;
};

export type VibeModeDockCommand =
    | { intent: VibeModeDockIntent.Open; payload?: OpenPayload }
    | { intent: VibeModeDockIntent.Close }
    | {
          intent: VibeModeDockIntent.GetVibeConsultation;
          payload: VibeConsultationPayload;
      }
    | {
          intent: VibeModeDockIntent.AskVibeMode;
          payload: AskVibeModePayload;
      }
    | {
          intent: VibeModeDockIntent.SessionDeleted;
          payload: SessionDeletedPayload;
      };

export type VibeModeDockState = {
    isOpen: boolean;
    unreadMessagesCount: number;
};

export const VIBE_MODE_DOCK_WIDTH_PX = 420;

export type VibeModeDockContract = {
    command: VibeModeDockCommand;
    state: VibeModeDockState;
};

export const getVibeModeDockChannel =
    (): MessageBusChannel<VibeModeDockContract> =>
        messageBus.channel<VibeModeDockContract>(
            'vibe-builder:vibe-mode-dock',
            {
                initialState: { isOpen: false, unreadMessagesCount: 0 }
            }
        );
